import { useEffect, useState } from 'react'
import { AxiosResponse } from 'axios'
import axiosInstance from '@config/axios'
import { serverPath } from '@constants/api-endpoints'
import { errorMapper } from '@utils/errorMapper'
import { ErrorMessages } from '@constants/errors'
import { useMessage } from '@hooks/useMessage'
import moment from 'moment'
import { ITableState } from '@utils/sort'
import { PlanInterface } from '@interfaces/plan.interface'
import { TableDataResponse } from '@interfaces/table.interface'
import { SubscriptionStatus } from '@enums/subscription'

export interface ICrmSubscription {
  createdAt: string
  crmId: string
  endDate: string
  id: string
  plan: PlanInterface
  planId: string
  startDate: string
  status: SubscriptionStatus
  updatedAt: string
}

interface Props {
  crmId?: string
  dates: [moment.Moment, moment.Moment]
  pagination?: ITableState
}

const useCrmSubscriptionsApi = ({ crmId, dates, pagination }: Props) => {
  const { error } = useMessage()
  const [isLoading] = useState(false)
  const [result, setResult] = useState<TableDataResponse<ICrmSubscription>>()
  const getData = async () => {
    if (crmId) {
      try {
        const { data }: AxiosResponse<TableDataResponse<ICrmSubscription>> =
          await axiosInstance.get(serverPath.CRM_SUBSCRIPTIONS + crmId, {
            params: {
              dates: [
                dates[0].format('YYYY-MM-DDTHH:mm:ss[Z]'),
                dates[1].format('YYYY-MM-DDTHH:mm:ss[Z]'),
              ],
              pageSize: pagination?.pagination ? pagination.pagination.pageSize : null,
              page: pagination?.pagination ? pagination.pagination.current : null,
              sort: pagination?.sort?.sort ?? null,
              field: pagination?.sort?.field ?? null,
            },
          })
        setResult(data)
      } catch (e) {
        error(errorMapper(ErrorMessages.GET_DATA, e), ErrorMessages.SERVER_ERROR)
      }
    }
  }

  useEffect(() => {
    getData().then()
  }, [crmId, dates, pagination])

  return { result: result, isLoading: isLoading ?? false }
}

export default useCrmSubscriptionsApi
